import { Action } from '@ngrx/store';
import { PortfolioStatus } from '../../model/PortfolioStatus';

export enum PortfolioStatusActionTypes {
  InitPortfolioStatuses = 'InitPortfolioStatuses',
  InitPortfolioSummary = 'InitPortfolioSummary',
  InitGroupUserPortfolio = 'InitGroupUserPortfolio',
  AddPortfolioStatus = 'AddPortfolioStatus',
  RemovePortfolioStatus = 'RemovePortfolioStatus',
  UpdatePortfolioStatus = 'UpdatePortfolioStatus',
}

export class InitPortfolioStatuses implements Action {
  readonly type = PortfolioStatusActionTypes.InitPortfolioStatuses;

  constructor(public payload: any) {
  }
}

export class InitPortfolioSummary implements Action {
  readonly type = PortfolioStatusActionTypes.InitPortfolioSummary;

  constructor(public payload: any) {
  }
}

export class InitGroupUserPortfolio implements Action {
  readonly type = PortfolioStatusActionTypes.InitGroupUserPortfolio;

  constructor(public payload: any) {
  }
}

export class AddPortfolioStatus implements Action {
  readonly type = PortfolioStatusActionTypes.AddPortfolioStatus;

  constructor(public payload: PortfolioStatus) {
  }
}

export class RemovePortfolioStatus implements Action {
  readonly type = PortfolioStatusActionTypes.RemovePortfolioStatus;

  constructor(public payload: string) {
  }
}

export class UpdatePortfolioStatus implements Action {
  readonly type = PortfolioStatusActionTypes.UpdatePortfolioStatus;

  constructor(public payload: PortfolioStatus) {
  }
}

export type PortfolioStatusActions =
  InitPortfolioStatuses |
  InitPortfolioSummary |
  InitGroupUserPortfolio |
  AddPortfolioStatus |
  RemovePortfolioStatus |
  UpdatePortfolioStatus;
